import RestService from './RestService';

export default class Videos extends RestService {
    constructor() {
        super('/videos');
    }
}
